import _ from "lodash";

/**
 * True when every visible option is already selected (and there is at least one visible option).
 * @param {Array<number>} selectedIds ids currently selected
 * @param {Array<number>} visibleIds ids of the options shown (after the search filter)
 */
export const areAllVisibleSelected = (selectedIds, visibleIds) =>
  !_.isEmpty(visibleIds) && _.difference(visibleIds, selectedIds).length === 0;

/**
 * Selection after pressing the select-all toggle: unselects the visible options when they are all
 * selected, otherwise adds them. Options hidden by the search keep their state.
 * @param {Array<number>} selectedIds ids currently selected
 * @param {Array<number>} visibleIds ids of the options shown (after the search filter)
 * @returns {Array<number>}
 */
export const toggleVisibleOptions = (selectedIds, visibleIds) =>
  areAllVisibleSelected(selectedIds, visibleIds)
    ? _.difference(selectedIds, visibleIds)
    : _.union(selectedIds, visibleIds);
